import { UserInfo, UserList } from 'generated/graphql';
import create from 'zustand';
import { combine, devtools, persist } from 'zustand/middleware';

interface IAuthState {
	user: UserInfo | null;
	Token: string | null;
	isLoggedIn: boolean;
}
const initialState: IAuthState = {
	user: null,
	Token: null,
	isLoggedIn: false,
};

const authStore = combine(initialState, (set) => ({
	setUser: (data: UserInfo) =>
		set(() => ({
			user: data,
		})),
	setToken: (token: string) =>
		set(() => ({
			Token: token,
		})),
	setIsLoggedIn: (logged: boolean) =>
		set(() => ({
			isLoggedIn: logged,
		})),
	logout: () =>
		set(() => ({
			Token: null,
			isLoggedIn: false,
			user: null,
		})),
}));

const useAuthStore = create(
	devtools(
		persist(authStore, {
			name: 'userAuth',
		})
	)
);

export default useAuthStore;
